"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOrderLineChangeRequest = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderNote_1 = require("./addOrderNote");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineById_1 = require("./getOrderLineById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const processOrderLineChangeRequest = async (supabase, order_id, order_line_id, message, to_address) => {
    try {
        // get the order
        const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
        const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
        if (!order_line.versions)
            return false;
        const order_line_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
        // create a new order note.
        const note = {
            order_item_id: order_line_id,
            note: message,
            order_id: order_id,
            pinned: true,
            created_by: order.client?.id,
            type: "CHANGE_REQUEST",
        };
        await (0, addOrderNote_1.addOrderNote)(supabase, note);
        if (order_line_version) {
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...order_line_version,
                status: helpers_1.OrderLineStatus.CHANGE_REQUESTED,
            });
        }
        // email support with request details
        const request_support_email = {
            language_code: "en",
            template_id: helpers_1.EMAIL_SUPPORT_ORDER_CHANGE_REQUEST,
            order_id: order.id,
            data: {
                message: message,
            },
        };
        if (to_address) {
            request_support_email.email_address = to_address;
        }
        request_support_email.cc_address = [
            "simon@golfsavers.com",
            "david@golfsavers.com",
        ];
        await (0, sendEmail_1.sendEmail)(request_support_email);
        return true;
    }
    catch (error) {
        throw new Error(error.message);
    }
};
exports.processOrderLineChangeRequest = processOrderLineChangeRequest;
